import { MRT_TableOptions } from "material-react-table";
import { createContext } from "react";
import { Post } from "src/api/client-api/post/postSchema";
import { SsqSsqHeading, SsqVersion } from "src/api/sure-api/ssq/useGetOneSsqVersion";
import { HeadingsSectionData } from "../QuestionnairesList";
import { ExportSubject } from "src/utils/exportNaming";

export type HeadingView = "grid" | "list";

export type QuestionnaireListInitialValues = {
    ssqVersion?: SsqVersion;
    post?: Post;
    isSsqLoading: boolean;
    isPostLoading: boolean;
    completeQuestionnaireUrl: (ssqSsqHeading: SsqSsqHeading) => string;
    scoresSection: ReactNode;
    displayDateLastModified?: boolean;
    enableTableHead?: boolean;
    muiTableProps?: Omit<MRT_TableOptions<HeadingsSectionData>["muiTableProps"], "columns" | "data">;
    exportSubject: ExportSubject;

    title: string;
    hasScoresToDisplay: boolean;

    questionnaireCompleteText: string;
    ssqSsqHeadings: SsqSsqHeading[];

    view: HeadingView;
    setView: (v: HeadingView) => void;

    isLocked: boolean;
    setLocked: (v: boolean) => void;

    isLockPostModalOpen: boolean;
    setLockPostModalOpen: (v: boolean) => void;

    canViewSsq?: boolean;
    canAnswerSsq?: boolean;
    canValidateSsq?: boolean;

    lastChangedAtDate: string;
    lastUpdatePost: string;

    isMobileOrTablet: boolean;
};
export const QuestionnaireListContext = createContext<QuestionnaireListInitialValues | null>(null);
